import { LogSink } from "./models";

export type LogSink = LogSink;
export * from "./services";
export { default as ServiceLogger } from "./ServiceLogger";
export { default as VueLogger } from "./VueLogger";
